import React from 'react';
import Text, { ITextProps } from '../animation/Text';
import classNames from 'classnames';

interface IHeadingTagProps extends ITextProps {
  tag?: string;
  heading: string;
  className?: string;
  dontAddClassFromTag?: boolean;
  children?: React.ReactNode;
}
const HeadingTag = ({ tag, heading, children, className, dontAddClassFromTag, ...props }: IHeadingTagProps) => {
  const polishedHeading = heading?.replace(/<(p|h[0-6])[^>]*>/g, '').replace(/<\/(p|h[0-6])>/g, '');
  let accessibilityLevel = 7;
  if (tag && parseInt(tag[1]) > 0) {
    accessibilityLevel = Number(tag[1]);
  }
  const content = polishedHeading ? { dangerouslySetInnerHTML: { __html: polishedHeading } } : { children };
  const _tag = tag && tag !== 'Not a heading' ? tag?.toLowerCase() : null;
  return (
    <Text
      tag={_tag || 'div'}
      role="heading"
      aria-level={accessibilityLevel}
      className={classNames('heading', !dontAddClassFromTag && _tag && `text-${_tag}`, className)}
      {...props}
      {...content}
    />
  );
};

export default HeadingTag;
